import { copyObjectGraph, exportObjectTreeGraph, GRAPH_COPY_OFFSET, placeComponentGraph } from '../graph/graphClipboard.js';
import { hassDomain } from './hassDomain.js';

/**
 * Duplicate the Home Assistant flow of copied objects onto the copies' page
 * (see copyObjectGraph and extractObjectsHass). Returns unpushed history commands.
 */
export function copyObjectHass(layer, uuidMap, hassStore, { getPage, offset = GRAPH_COPY_OFFSET }) {
    return copyObjectGraph(layer, uuidMap, hassStore, hassDomain, { getPage, offset, description: 'Copy HA flow' });
}

/** File-form flow of an object subtree for a custom component (see exportObjectTreeGraph). */
export function exportObjectTreeHass(root, getPage) {
    return exportObjectTreeGraph(root, getPage, hassDomain);
}

/** Add a custom component's file-form flow to `page` (see placeComponentGraph). */
export function placeComponentHass(page, hass, uuidOfComponentId, offset = { x: 0, y: 0 }) {
    return placeComponentGraph(page, hass, uuidOfComponentId, offset, hassDomain);
}
